import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SuratJalan.css";
import PrintRace from "../zustand/Store/untukPrint/PrintRace";
import DetailSpRace from "../routes/Race/WebAdmin/splist/Detailsplist/DetailSpRace";
import { Col, Row } from "react-bootstrap";
import JsBarcode from "jsbarcode-fixed";
import moment from "moment";
import { printAfterRender } from "../util/printAfterRender";
import FourPlyNotes from "./FourPlyNotes";

const getPrintAddress = (item) => {
  const spNumber = item?.sp || item?.so || item?.sm || "";
  const isRoSp = typeof spNumber === "string" && spNumber.startsWith("21-RO-");

  if (isRoSp) {
    return item?.alamatMuat || item?.alamatBongkar || item?.alamat || "-";
  }

  return item?.alamatBongkar || item?.alamatMuat || item?.alamat || "-";
};

const SuratJalan = () => {
  const setDetailSJRace = PrintRace((state) => state.setDetailSJRace);
  const DetailSJRace = PrintRace((state) => state.DetailSJRace);
  const includeFourPlyNotes =
    new URLSearchParams(window.location.search).get("format") === "sj4ply";

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(`iniurl`, urlParams);
    const dataString = urlParams.get("data");
    if (dataString) {
      const data = JSON.parse(decodeURIComponent(dataString));
      setDetailSJRace(data);
      // barcode digambar di effect berikutnya, setelah layout (retur / surat jalan) ter-render
    }
  }, [setDetailSJRace]);

  useEffect(() => {
    // Cetak hanya setelah data ada dan sudah di-render; window.print() ditunda ke luar fase commit React
    const hasData =
      DetailSJRace &&
      (Array.isArray(DetailSJRace)
        ? DetailSJRace.length > 0
        : Object.keys(DetailSJRace).length > 0);
    if (!hasData) return undefined;
    if (document.querySelector("#barcode")) {
      JsBarcode(`#barcode`, `${DetailSJRace.sm}`, {
        format: "CODE128",
        lineColor: "#00000",
        width: 1.9,
        height: 50,
        displayValue: true,
      });
    }
    return printAfterRender();
  }, [DetailSJRace]);
  const date = new Date();
  const hariini = moment(date).format(`YYYY-MM-DD`);
  useEffect(() => {
    document.title = `SJRCPrint_All_${hariini}_1hal`;
  }, []);
  return (
    <div style={{ backgroundColor: "white" }}>
      {/* Print-only CSS to constrain to one A4 page for RETUR layout */}
      <style>{`
        /* Only apply to Retur Order layout; avoid global overrides */
        @media print {
          .avoid-break { break-inside: avoid; page-break-inside: avoid; }
          .retur-page { width: 210mm; height: 297mm; padding: 0; box-sizing: border-box; overflow: hidden; }
          .retur-tight p { margin: 4px 0; }
          .retur-tight table { margin: 0; }
          .retur-tight h2 { margin: 4px 0; }
        }
      `}</style>
      <div className="container mb-5">
        {DetailSJRace?.retur === 0 ? (
          // RETUR ORDER layout (match PrintRO.js) forced to single A4 page
          <div className="retur-page retur-tight">
            <div className="d-flex justify-content-center avoid-break">
              <Row style={{ width: "100%" }}>
                <Col className="d-flex align-items-center">
                  <img
                    className="justify-content-start"
                    src="https://elogs.eurekalogistics.co.id/assets/admin/dist/img/logo-race.png"
                    alt=""
                    style={{ maxWidth: "50%", maxHeight: "50%" }}
                  />
                </Col>
                <Col className="d-flex justify-content-center align-items-center">
                  <div className="text-center">
                    <h2 style={{ fontSize: 16 }}>
                      <b>RETUR ORDER</b>
                    </h2>
                  </div>
                </Col>
                <Col className="d-flex justify-content-end align-items-end">
                  <div className="text-center">
                    <svg id={`barcode`}></svg>
                  </div>
                </Col>
              </Row>
            </div>

            {/* spacing similar to Surat Jalan handled by default margins */}

            <Row className="mt-2 avoid-break">
              <Col style={{ fontSize: 12, fontWeight: "bold" }}>
                <table>
                  <tbody>
                    <tr>
                      <td className="nowrap">Nomor Retur</td>
                      <td className="mx-2">:</td>
                      <td>{DetailSJRace.sp}</td>
                    </tr>
                    <tr>
                      <td className="nowrap">Tanggal</td>
                      <td className="mx-2">:</td>
                      <td>{DetailSJRace.pickupDate}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col style={{ fontSize: 12, fontWeight: "bold" }}>
                <table>
                  <tbody>
                    <tr>
                      <td>Nama Driver</td>
                      <td className="mx-2">:</td>
                      <td>{DetailSJRace.driver}</td>
                    </tr>
                    <tr>
                      <td>Plat Nomor</td>
                      <td className="mx-2">:</td>
                      <td>{DetailSJRace.nopol}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>

            <Row
              className="mt-1 avoid-break"
              style={{ fontSize: 12, fontWeight: "bold" }}
            >
              <Col>
                <table>
                  <tbody>
                    <tr>
                      <td className="nowrap">Alamat</td>
                      <td className="mx-2">:</td>
                      <td>{getPrintAddress(DetailSJRace)}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>

            <table
              style={{ fontSize: 12, border: "0.2px solid black" }}
              className="table table-bordered mt-3 avoid-break"
            >
              <thead className="text-center">
                <tr>
                  <th
                    rowSpan="2"
                    className="align-middle"
                    style={{ width: "5%" }}
                  >
                    NO
                  </th>
                  <th
                    rowSpan="2"
                    className="align-middle"
                    style={{ width: "35%" }}
                  >
                    NAMA PELANGGAN
                  </th>
                  <th
                    rowSpan="2"
                    className="align-middle"
                    style={{ width: "35%" }}
                  >
                    MEMO
                  </th>
                  <th colSpan="2">JUMLAH</th>
                </tr>
                <tr>
                  <th>COLLY</th>
                  <th>IKAT</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-center">
                  <td>1</td>
                  {/* <td>{DetailSJRace.sekolahTujuan}</td> */}
                  <td>{DetailSJRace.sekolahTujuan}</td>
                  <td>
                    {DetailSJRace.memo && DetailSJRace.memo !== "-"
                      ? DetailSJRace.memo
                      : DetailSJRace.sjErl && DetailSJRace.sjErl !== "-"
                        ? DetailSJRace.sjErl
                        : "FPPBRNYA TIDAK ADA NOMORNYA"}
                  </td>
                  <td>{DetailSJRace.koli}</td>
                  <td>{DetailSJRace.ikat}</td>
                </tr>
                <tr>
                  <td
                    colSpan="3"
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                    TOTAL
                  </td>
                  <td className="text-center">{DetailSJRace.koli}</td>
                  <td className="text-center">{DetailSJRace.ikat}</td>
                </tr>
              </tbody>
            </table>

            <div className="avoid-break" style={{ fontSize: 8 }}>
              <b>Note :</b>
            </div>
            <div
              className="avoid-break"
              style={{
                border: "0.2px solid black",
                padding: 10,
                textAlign: "start",
              }}
            >
              <p>
                <b>
                  <i style={{ fontSize: 16 }}>
                    Penarikan retur dilakukan hanya untuk barang yang telah
                    terbungkus (ikat/koli), tersegel, berlabel, dan sesuai
                    dengan jumlah yang tercantum pada dokumen retur. Raja Cepat
                    tidak bertanggung jawab atas isi, kelengkapan, maupun
                    kondisi barang setelah diterima oleh gudang penerima.
                  </i>
                </b>
              </p>
            </div>

            <div className="row text-center mt-3 avoid-break">
              <Row>
                <Col style={{ fontSize: 12, fontWeight: "bold" }}>
                  <p>Pelanggan</p>
                  <p style={{ marginTop: 40 }}>
                    (.............................................)
                  </p>
                  <p>
                    <i>Nama, Tanda Tangan, Tanggal, dan Stempel</i>
                  </p>
                  <p>
                    <i>No HP:............................................</i>
                  </p>
                </Col>
                <Col style={{ fontSize: 12, fontWeight: "bold" }}>
                  <p>Driver</p>
                  <p style={{ marginTop: 40 }}>
                    (.............................................)
                  </p>
                  <p>
                    <i>Nama, Tanda Tangan, dan Tanggal</i>
                  </p>
                  <p>
                    <i>No HP:............................................</i>
                  </p>
                </Col>
                <Col style={{ fontSize: 12, fontWeight: "bold" }}>
                  <p>Penerima</p>
                  <p style={{ marginTop: 40 }}>
                    (.............................................)
                  </p>
                  <p>
                    <i>Nama, Tanda Tangan, dan Tanggal</i>
                  </p>
                  <p>
                    <i>No HP:............................................</i>
                  </p>
                </Col>
              </Row>
            </div>
            {includeFourPlyNotes && (
              <FourPlyNotes
                fontSize={12}
                fontWeight="normal"
                marginTop={16}
                lineHeight={1.4}
              />
            )}
          </div>
        ) : (
          // Original SURAT JALAN layout (unchanged)
          <>
            <div>
              <div className="d-flex">
                <Row style={{ width: "100%" }}>
                  <Col>
                    <img
                      className="justify-content-start"
                      src="https://elogs.eurekalogistics.co.id/assets/admin/dist/img/logo-race.png"
                      alt=""
                      style={{ maxWidth: "50%", maxHeight: "50%" }} // Ensure the image fits well
                    />
                  </Col>
                  <Col>
                    <div className="text-center justify-content-center">
                      <br />
                      <h2 style={{ fontSize: 16 }}>
                        <b>SURAT JALAN</b>
                      </h2>
                    </div>
                  </Col>
                  <Col>
                    <div className="text-end justify-content-end">
                      <svg id={`barcode`}></svg>
                    </div>
                  </Col>
                </Row>
              </div>
              <br />
              <br />
              <Row className="row">
                <Col span={7} style={{ fontSize: 12 }}>
                  <table>
                    <tbody>
                      <tr>
                        <td className="nowrap">Nomor Surat Jalan</td>
                        <td className="mx-2">:</td>
                        <td>{DetailSJRace.sm}</td>
                      </tr>
                      <tr>
                        <td className="nowrap">Tanggal</td>
                        <td className="mx-2">:</td>
                        <td>{DetailSJRace.pickupDate}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col span={5} style={{ fontSize: 12 }}>
                  <table>
                    <tbody>
                      <tr>
                        <td>Nama Driver</td>
                        <td className="mx-2">:</td>
                        <td>{DetailSJRace.driver}</td>
                      </tr>
                      <tr>
                        <td>Plat Nomor</td>
                        <td className="mx-2">:</td>
                        <td>{DetailSJRace.nopol}</td>
                      </tr>
                      {(DetailSJRace.parent_sm?.msm || DetailSJRace.referensi_sj_asal) && (
                        <tr>
                          <td>SJ Asal</td>
                          <td className="mx-2">:</td>
                          <td>{DetailSJRace.parent_sm?.msm || DetailSJRace.referensi_sj_asal}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Col span={5} style={{ fontSize: 12 }}>
                <table>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          backgroundColor: "",
                          // marginRight: 10,
                          width: 114,
                        }}
                        className="nowrap ontop"
                      >
                        Alamat
                      </td>
                      <td
                        style={{ backgroundColor: "" }}
                        className="ontop mx-2 "
                      >
                        :
                      </td>
                      <td>{getPrintAddress(DetailSJRace)}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </div>
            <br />

            <table
              style={{ fontSize: 12, border: "0.2px  black" }}
              className="table table-bordered"
            >
              <thead className="text-center">
                <tr>
                  <th rowSpan="2" className="align-middle">
                    NO
                  </th>
                  <th rowSpan="2" className="align-middle">
                    NO SJ PELANGGAN
                  </th>
                  <th rowSpan="2" className="align-middle">
                    NAMA PELANGGAN
                  </th>
                  <th colSpan="3">JUMLAH</th>
                </tr>
                <tr>
                  <th>FAKTUR</th>
                  <th>COLLY</th>
                  <th>IKAT</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ textAlign: "center" }}>
                  <td>{1}</td>
                  <td>{DetailSJRace.sjErl}</td>
                  <td>{DetailSJRace.sekolahTujuan}</td>
                  <td>{DetailSJRace.jumlahFaktur}</td>
                  <td>{DetailSJRace.koli}</td>
                  <td>{DetailSJRace.ikat}</td>
                </tr>
                <tr>
                  <td
                    colSpan="3"
                    style={{
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    TOTAL
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {DetailSJRace.jumlahFaktur}
                  </td>
                  <td style={{ textAlign: "center" }}>{DetailSJRace.koli}</td>
                  <td style={{ textAlign: "center" }}>{DetailSJRace.ikat}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ fontSize: 8 }}>
              <b>Note :</b>
            </div>
            <div
              style={{
                border: "0.2px solid black",
                padding: 10,
                textAlign: "start",
              }}
            >
              <p>
                <b>
                  <i style={{ fontSize: 16 }}>
                    Buku yang diterima 100% menjadi tanggung jawab penerima dan
                    tidak bisa diserahkan ke pihak manapun tanpa sepengetahuan
                    pengirim. Jika ada pihak-pihak yang mengatasnamakan RAJA
                    CEPAT dapat menghubungi Customer Service PT Raja Cepat
                    Nusantara di nomor 082118334545.
                  </i>
                </b>
              </p>
            </div>
            <br />
            <br />
            <br />
            <br />
            <div className="row text-center mt-3">
              <Col style={{ fontSize: 12 }}>
                <p>Pengirim</p>
                <br />
                <br />
                <br />
                <p>(.............................................)</p>
                <p>
                  <i>Nama, Tanda Tangan, dan Tanggal</i>
                </p>
                <p>
                  <i>No HP:............................................</i>
                </p>
              </Col>
              <Col style={{ fontSize: 12 }}>
                <p>Penerima</p>
                <br />
                <br />
                <br />
                <p>(.............................................)</p>
                <p>
                  <i>Nama, Tanda Tangan, dan Tanggal</i>
                </p>
                <p>
                  <i>No HP:............................................</i>
                </p>
              </Col>
            </div>
            {includeFourPlyNotes && <FourPlyNotes fontWeight="normal" />}
            {/* <hr className="new2" /> */}
            <br />
            <br />
            <br />
          </>
        )}
      </div>
    </div>
  );
};

export default SuratJalan;
